import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Circle, GoogleMap, InfoWindow, Marker, Polygon, Polyline, useJsApiLoader } from '@react-google-maps/api';
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';
import { Button, Checkbox, Collapse, Divider, Switch, Typography } from 'antd';
import { saveAs } from 'file-saver';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AssetDropIcon from '../assets/AssetDropIconNew.svg';
import DefaultMap from '../assets/DefaultMapView.png';
import ObstructionIcon from '../assets/ObstructionIcon.svg';
import SatelliteMap from '../assets/SateliteMapView.png';
import BuildingIcon from '../assets/building_location.png';
import PillIcon from '../assets/line_length_pill.svg';
import MyLocationIcon from '../assets/locateme.png';
import Trailer from '../assets/trailer_emergency.svg';
import AssetLegend from '../components/AssetLegend';
import CustomPopup from '../components/CustomInfoMaps/CustomMap';
import { ImageOverlay } from '../components/CustomInfoMaps/ImageOverlay';
import { RFImageOverlay } from '../components/CustomInfoMaps/RFImageOverlay';
import ErrorAlert from '../components/ErrorAlert';
import LocateMe from '../components/LocateMe';
import MapSpinner from '../components/MapSpinner';
import Modal from '../components/Modal';
import OutdoorRoutes from '../components/OutdoorRoutes';
import RFLegend from '../components/RFLegend';
import WarningAlert from '../components/WarningAlert';
import ZoomMinus from '../components/ZoomMinus';
import ZoomPlus from '../components/ZoomPlus';
import { assetStatusDot, wifiStatusIcon } from '../constants/GlobalConstants';
import MAP_API_KEY, { INSTALLER_RADIUS } from '../constants/map';
import AssetProps, { AssetObj } from '../interfaces/AssetProps';
import { ApiHandler } from '../services/apiHandler';
import {
  getClusterIcon,
  getLineCenter,
  getMarkerIcon,
  getOrganisationId,
  getRole,
  getSignalStrengthColor,
  getTechnology,
  legendTechDisplay,
} from '../services/helper';
import './Outdoor.css';

interface OutdoorProps {
  preSelectedAsset: AssetObj | undefined; // This is used to preselect an asset on the map. This is used when user clicks on "Show on Map" in Network Activity.
  goToProfile: () => void;
  searchedLocationMap: boolean;
  currentPage: string;
  setCurrentPage: (page: string) => void;
  centerMap: any;
  activeTechnology: string;
  boundsPolygon: any[];
}

const Outdoor: React.FC<OutdoorProps> = ({
  preSelectedAsset = undefined,
  goToProfile,
  searchedLocationMap,
  currentPage,
  setCurrentPage,
  centerMap,
  activeTechnology,
  boundsPolygon,
}) => {
  let navigate = useNavigate();
  const [libraries] = useState<Libraries>(['places', 'geometry', 'drawing']);

  const [assetDropLocation, setAssetDropLocation] = useState({ lat: 0, lng: 0 });
  const [calculateLocation, setCalculateLocation] = useState({ lat: '', lng: '' });
  const [assets, setAssets] = useState<any[]>([]);
  const [buildings, setBuildings] = useState<any[]>([]);
  const [venues, setVenues] = useState<any[]>([]);
  const [fetchAssets, setFetchAssets] = useState(false);
  // const [currentPage, setCurrentPage] = useState('home');
  const [userLocation, setUserLocation] = useState({ lat: 0, lng: 0 });
  const [searchedLocation, setSearchedLocation] = useState(false);
  const [isAzimuthActive, setIsAzimuthActive] = useState(false);
  const [map, setMap] = useState<google.maps.Map>();
  const [mapTilesLoaded, setMapTilesLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [assetHover, setAssetHover] = useState(false);
  const [measurePoints, setMeasurePoints] = useState<any[]>([]);
  const [assetsForMeasure, setAssetsForMeasure] = useState<string[]>([]);
  const [measurePopup, setMeasurePopup] = useState<boolean>(false);
  const [measureInfo, setMeasureInfo] = useState<any>({});
  const [hoverData, setHoverData] = useState({
    position: { lat: 0, lng: 0 },
    trackingId: '',
    serialNumber: '',
    mountingType: '',
    technologyType: '',
    status: '',
    cbrsNodeName: '',
    vendor_type: '',
  });
  const [selectedAsset, setSelectedAsset] = useState<AssetProps | undefined>(undefined);
  const [assetEditAction, setAssetEditAction] = useState('');
  const [rmaNewSerialNumber, setRmaNewSerialNumber] = useState<string[]>([]);
  const [venueBoundaryPolygon, setVenueBoundaryPolygon] = useState<google.maps.Polygon>();
  const [venueBoundaryPath, setVenueBoundaryPath] = useState<google.maps.LatLng[]>([]);
  const [drawMode, setDrawMode] = useState<'draw' | 'draw_building' | 'draw_emergency' | null>(null);
  const [emergencyBoundaryPolygon, setEmergencyBoundaryPolygon] = useState<google.maps.Polygon>();
  const [emergencyBoundaryPath, setEmergencyBoundaryPath] = useState<google.maps.LatLng[]>([]);
  // const [venueBoundaryColor, setVenueBoundaryColor] = useState('#0059b2');
  const [currentVenueId, setCurrentVenueId] = useState('');
  const [currentBuildings, setCurrentBuildings] = useState<any[]>([]);
  const [currentBuildingId, setCurrentBuildingId] = useState('');
  const [currentFloorId, setCurrentFloorId] = useState('');
  const [floorPlanGeometry, setFloorPlanGeometry] = useState<any>(null);
  // const [buildingBoundaryPolygon, setBuildingBoundaryPolygon] = useState<google.maps.Polygon>();
  // const [buildingBoundaryColor, setBuildingBoundaryColor] = useState('#0059b2');
  const [showControls, setShowControls] = useState(true);
  const [center, setCenter] = useState({
    lat: 39.600292,
    lng: -104.889944,
  });
  const [mapAssetFilters, setMapAssetFilters] = useState<any[]>(legendTechDisplay.map((item) => item.value));
  const [rfImageUrl, setRFImageUrl] = useState('');
  const [rfBounds, setRFBounds] = useState<null | { north: number; south: number; east: number; west: number }>(null);
  const [isEmergency, setIsEmergency] = useState(false);
  const [selectedFloor, setSelectedFloor] = useState<any>(null);
  const [selectedTechnology, setSelectedTechnology] = useState(getTechnology());
  const [floorPlan, setFloorPlan] = useState('');
  const [imageBounds, setImageBounds] = useState<any>();
  const [imageRotation, setImageRotation] = useState<any>(null);
  const [floorGeometries, setFloorGeometries] = useState<any[]>([]);
  const [isPlacingWorkOrder, setIsPlacingWorkOrder] = useState(false);
  const [totalServiceDrops, setTotalServiceDrops] = useState<any[]>([]);
  const [rfAnalysisForm, setRfAnalysisForm] = useState<any>({
    simulation_provider: 'cloudrf',
    internal_radius: 1000,
    radius: 10000,
    receiver_height: 6,
    receiver_gain: 18.5,
    receiver_sensitivity: -100,
    pm: 1,
    pe: 2,
    ked: 1,
    rel: 90,
    rcs: 1,
    elevation: 2,
    landcover: 1,
    buildings: 1,
    obstacles: 1,
  });
  const [showRfAnalysis, setShowRfAnalysis] = useState(true);
  const [showRfRadius, setShowRfRadius] = useState(true);
  const [rfLocation, setRfLocation] = useState({ lat: 0, lng: 0 });
  const [workOrderId, setWorkOrderId] = useState('');
  const [rfParameters, setRfParameters] = useState<any>({});
  const [rfResults, setRfResults] = useState<any>({});
  const [title, setTitle] = useState('');
  const [currentCreateTechnology, setCurrentCreateTechnology] = useState('');
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [building, setBuilding] = useState<any>();
  const [hiddenVenueId, setHiddenVenueId] = useState<string>('');
  const [mapManagerVenueDisplay, setMapManagerVenueDisplay] = useState<boolean>(true);
  const [mapManagerBuildingDisplay, setMapManagerBuildingDisplay] = useState<boolean>(true);
  const [mapManagerRfDisplay, setMapManagerRFDisplay] = useState(true);
  const [mapManagerMapDisplay, setMapManagerMapDisplay] = useState<string>('ROADMAP');
  const [mapManagerShowAllAsset, setMapManagerShowAllAsset] = useState<boolean>(true);
  const [mapManagerShowAllLayers, setMapManagerShowAllLayers] = useState<boolean>(true);
  const [mapManagerConnectivityDisplay, setMapManagerConnectivityDisplay] = useState<boolean>(true);
  const [mapManagerAssetGroupsDisplay, setMapManagerAssetGroupsDisplay] = useState<boolean>(true);
  const [workOrderVenueId, setWorkOrderVenueId] = useState();
  const [workOrderBuildingId, setWorkOrderBuildingId] = useState();

  const [viewRFPathAnalysis, setViewRFPathAnalysis] = useState(false);
  const [viewImage, setViewImage] = useState({
    image: '',
    fileName: '',
    popup: false,
    path: '',
  });
  const [showActionPanel, setShowActionPanel] = useState(true);
  const [obstructions, setObstructions] = useState<any[]>([]);
  const [mapManagerObstructionsDisplay, setMapManagerObstructionsDisplay] = useState<boolean>(true);

  useEffect(() => {
    if (localStorage.getItem('center') && JSON.parse(localStorage.getItem('center') as string) !== null) {
      // console.log('Setting center from localStorage: ', JSON.parse(localStorage.getItem('center') as string));
      setCenter(JSON.parse(localStorage.getItem('center') as string));
    } else if (navigator.geolocation) {
      try {
        if (!navigator.geolocation) {
          centerUserLocation(null, false);
          return;
        }
        navigator.geolocation.getCurrentPosition(
          (position: GeolocationPosition) => {
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            centerUserLocation(pos, true);
          },
          (e: any) => {
            console.log('Error fetching user location: ', e);
          },
          { timeout: 3000 }
        );
      } catch (e: any) {
        // console.log('Error fetching user location: ', e);
        setCenter({ lat: 39.600292, lng: -104.889944 });
      }
    }
  }, []);

  useEffect(() => {
    if (activeTechnology && map) {
      var tempFilterList: any[] = [];
      if (activeTechnology === 'cbrs_5g') {
        tempFilterList = ['cbrs_5g', 'cpe_cbsd'];
      } else if (activeTechnology === 'wifi_6e') {
        tempFilterList = ['wifi_6e', 'cpe_wifi'];
      } else if (activeTechnology === 'cpe_cbsd') {
        tempFilterList = ['cpe_cbsd', 'cbrs_5g'];
      } else if (activeTechnology === 'cpe_wifi') {
        tempFilterList = ['cpe_wifi', 'wifi_6e'];
      } else if (activeTechnology === 'tarana') {
        tempFilterList = ['tarana', 'tarana_cpe'];
      } else if (activeTechnology === 'tarana_cpe') {
        tempFilterList = ['tarana_cpe', 'tarana'];
      } else {
        tempFilterList = legendTechDisplay.map((item) => item.value);
      }
      setMapAssetFilters(tempFilterList);
      getAssetsInBounds(map, tempFilterList);
      setMapManagerMapDisplay(map?.getMapTypeId()?.toUpperCase() as string);
    }
  }, [activeTechnology, map]);

  const getTechnologyName: any = {
    wifi_6e: 'AP',
    cbrs_5g: 'Base Station',
    cpe_wifi: 'Wi-Fi CPE',
    cpe_cbsd: 'CPE CBSD',
    tarana: 'Base Node',
    tarana_cpe: 'Remote Node',
  };

  const mapStyle = {
    width: `${
      // ['addBuilding', 'editAsset', 'addAssetCommon', 'editBuilding', 'addVenue', 'editVenue', 'floorDetails'].includes(currentPage) ? '100%' :
      '100%'
    }`,
    height: 'calc(100vh - 58px)',
    zIndex: drawMode !== null ? 9 : undefined,
  };

  const mapOptions = {
    minZoom: 4,
    disableDefaultUI: true,
    styles: [
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }],
      },
    ],
    keyboardShortcuts: false,
    tilt: 0,
  };

  const { isLoaded } = useJsApiLoader({
    id: 'map',
    googleMapsApiKey: MAP_API_KEY,
    libraries,
  });

  useEffect(() => {
    if (boundsPolygon?.length > 0 && map) {
      const bounds = new window.google.maps.LatLngBounds();
      boundsPolygon.forEach((point: any) => {
        bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
      });
      setTimeout(() => {
        map.fitBounds(bounds);
      }, 1000);
    }
  }, [boundsPolygon, map]);

  useEffect(() => {
    if (selectedAsset !== undefined) {
      setCurrentPage('assetDetails');
    }
    fetchAssetsOnIdle();
  }, [selectedAsset]);

  useEffect(() => {
    if (centerMap) {
      setCenter(centerMap);
      map?.setZoom(20);
    }
  }, [centerMap]);

  useEffect(() => {
    if (typeof searchedLocationMap !== undefined) {
      setSearchedLocation(searchedLocationMap);
    }
  }, [searchedLocationMap]);

  // useEffect(() => {
  //   if (currentPageMap) {
  //     setCurrentPage(currentPageMap);
  //   }
  // }, [currentPageMap]);

  useEffect(() => {
    if (['addAssetCommon'].includes(currentPage)) {
      if (!currentBuildingId && !building) {
        setAssetDropLocation(
          selectedAsset?.asset.latitude
            ? {
                lat: selectedAsset?.asset.latitude ?? 0,
                lng: selectedAsset?.asset.longitude ?? 0,
              }
            : {
                lat: center.lat,
                lng: center.lng,
              }
        );
      }
    }
    if (currentPage === 'createRfSimulation') {
      setAssets([]);
      getNodesInRadius(rfLocation, rfAnalysisForm.internal_radius, getTechnology());
    }
    if (currentPage === 'home') {
      setCurrentVenueId('');
      setCurrentBuildingId('');
      setCurrentFloorId('');
      setFloorGeometries([]);
      setFloorPlan('');
      setSelectedFloor(null);
      setImageBounds(null);
      setImageRotation(null);
      setSelectedAsset(undefined);
      setAssetEditAction('');
      setFloorPlanGeometry(null);
      unsetGeoJSON();
      setObstructions([]);
    }
    if (!['floorDetails', 'floorActions', 'assetDetails', 'addAssetCommon', 'editAsset'].includes(currentPage)) {
      unsetGeoJSON();
    }
    if (currentPage === 'buildingDetails') {
      setBuilding(null);
      panToBuilding(currentBuildingId);
    }
    if (currentPage === 'venueDetails') {
      panToVenue(currentVenueId);
    }
    if (['addAssetCommon', 'cpePreloaded', 'rfAnalysis'].includes(currentPage)) {
      const center = map?.getCenter();
      map?.setOptions({
        zoom: 18,
        center: center,
      });
    }

    if (['editAsset'].includes(currentPage)) {
      const center = map?.getCenter();
      map?.setOptions({
        zoom: 22,
        center: center,
      });
    }

    if (currentPage === 'floorActions') {
      // setFloorPlanGeometry(null);
      setFloorGeometries([]);
    }
    if (currentPage === 'editAsset') {
      setCurrentCreateTechnology(selectedAsset?.asset.technology_type as string);
    }
    if (currentPage !== 'assetDetails') setViewRFPathAnalysis(false);
  }, [currentPage]);

  useEffect(() => {
    if (mapTilesLoaded) {
      const zoom = localStorage.getItem('zoom');
      if (zoom) {
        map?.setZoom(parseInt(zoom));
      }
      fetchAssetsOnIdle(); // Fetch assets when map tiles are loaded
      if (preSelectedAsset) {
        setFetchAssets(true);
        assetInFocus(preSelectedAsset);
        preSelectedAsset = undefined;
      }
    }
  }, [mapTilesLoaded]);

  useEffect(() => {
    if (currentFloorId && currentFloorId !== '') {
      if (['addAssetCommon', 'cpePreloaded', 'editAsset', 'buildingDetails'].includes(currentPage)) {
        // console.log('Fetching floor image for asset addition');
        getFloorImage({ id: currentFloorId });
      }
      getAssetsInFloor(currentFloorId);
    }
    // else if (currentBuildingId && currentBuildingId !== '') getAssetsInBuilding(currentBuildingId);
    // else if (currentVenueId && currentVenueId !== '') getAssetsInVenue(currentVenueId);
    // else getAssetsInBounds(map);
  }, [currentFloorId]);

  useEffect(() => {
    fetchAssetsOnIdle();
  }, [fetchAssets]);

  useEffect(() => {
    if (!venueBoundaryPolygon) return;
    if (!venueBoundaryPath || venueBoundaryPath.length < 3) return;
    const path = venueBoundaryPolygon.getPath();
    if (!path) return;

    const updatePath = () => {
      const arr = path.getArray().map((p) => new google.maps.LatLng(p.lat(), p.lng()));
      setVenueBoundaryPath(arr);
    };

    google.maps.event.addListener(path, 'insert_at', updatePath);
    google.maps.event.addListener(path, 'remove_at', updatePath);
    google.maps.event.addListener(path, 'set_at', updatePath);
  }, [venueBoundaryPolygon, venueBoundaryPath]);

  useEffect(() => {
    if (!emergencyBoundaryPolygon) return;
    if (!emergencyBoundaryPath || emergencyBoundaryPath.length < 3) return;
    const path = emergencyBoundaryPolygon.getPath();
    if (!path) return;

    const updatePath = () => {
      const arr = path.getArray().map((p) => new google.maps.LatLng(p.lat(), p.lng()));
      setEmergencyBoundaryPath(arr);
    };

    google.maps.event.addListener(path, 'insert_at', updatePath);
    google.maps.event.addListener(path, 'remove_at', updatePath);
    google.maps.event.addListener(path, 'set_at', updatePath);
  }, [emergencyBoundaryPolygon, emergencyBoundaryPath]);

  const panToBuilding = (buildingId: any) => {
    if (map && currentBuildings.length > 0) {
      let building_location = currentBuildings.filter((building) => building.id === buildingId);
      if (building_location.length > 0) {
        map.setZoom(20);
        map.panTo(building_location[0].location);
      }
    }
  };

  const panToVenue = (venueId: any) => {
    if (map && venues.length > 0) {
      let venue_location = venues.filter((venue) => venue.id.toString() === venueId.toString());
      if (venue_location.length > 0) {
        map.setZoom(20);
        map.panTo(venue_location[0].location);
      }
    }
  };

  const setUserLocationCenter = () => {
    try {
      if (!navigator.geolocation) {
        centerUserLocation(null, false);
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          centerUserLocation(pos, true);
        },
        (e: any) => {
          console.log('Error fetching user location: ', e);
        },
        { timeout: 3000 }
      );
    } catch (e: any) {
      setErrorMessage(e);
      setErrorAlert(true);
    }
  };

  const setErrorMsg = (error: any) => {
    if (error.doLogout === true) {
      setErrorMessage('Session Timed Out');
      setErrorAlert(true);
      setTimeout(() => navigate('/login', { replace: true }), 2000);
      return;
    }
    setErrorMessage(error?.data?.message);
    setErrorAlert(true);
  };

  const fetchAssetsOnIdle = () => {
    if (!fetchAssets) return;
    getAssetsInBounds(map);

    if (currentFloorId) {
      getAssetsInFloor(currentFloorId);
    } else if (currentBuildingId) {
      getAssetsInBounds(map);
      // getAssetsInBuilding(currentBuildingId);
    } else if (currentVenueId) {
      getAssetsInBounds(map);
      getAssetsInVenue(currentVenueId);
    }
  };

  const getAssetsInBounds = async (map: google.maps.Map | undefined, mapFilter: any[] | null = null) => {
    const zoomLevel = map?.getZoom();
    const bounds = map?.getBounds();
    if (zoomLevel === undefined || bounds === undefined) return;
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const requestBody: any = {
      northEast: {
        lat: ne.lat(),
        lng: ne.lng(),
      },
      southWest: {
        lat: sw.lat(),
        lng: sw.lng(),
      },
      zoom: zoomLevel,
      technology_type: getTechnology(),
    };
    if (getRole() === 'installer' && getOrganisationId() === 1) {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          requestBody.location = pos;
          assetsInBoundsApi(requestBody, zoomLevel);
        },
        (e: any) => {
          console.log('Error fetching user location: ', e);
        },
        { timeout: 3000 }
      );
    } else {
      assetsInBoundsApi(requestBody, zoomLevel, mapFilter);
    }
  };

  const getNodesInRadius = (location: any, radius: number, technology: string) => {
    if (!location || (location?.lat === 0 && location?.lng === 0) || !radius || !technology) return;
    setLoading(true);
    ApiHandler({
      apiName: 'nodesInRadius',
      body: { latitude: location?.lat, longitude: location?.lng, radius: radius, technology_type: technology },
      params: {},
    })
      .then((response: any) => {
        setAssetSectorIcons(response);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorMsg(error);
      });
  };
  // Below API depends on getAssetsInBounds function
  const assetsInBoundsApi = (requestBody: any, zoomLevel: any, mapFilter: any[] | null = null) => {
    setLoading(true);
    setFetchAssets(false);
    if (['addAssetCommon', 'editVenue'].includes(currentPage) || (currentPage == 'editBuilding' && drawMode === 'draw')) {
      setLoading(false);
      return;
    }
    if (mapFilter) requestBody['map_asset_filters'] = mapFilter;
    else requestBody['map_asset_filters'] = mapAssetFilters;
    ApiHandler({ apiName: 'assetsInBounds', body: requestBody, params: {} })
      .then(async (response: any) => {
        if (response?.data?.venues) setVenues(response.data.venues ?? []);
        if (response?.data?.buildings) setBuildings(response.data.buildings);
        if (zoomLevel > 15) {
          setAssetSectorIcons(response);
        } else if (zoomLevel <= 13) {
          let clusters: any[] = [];
          for (let asset of response.data) {
            let icon: google.maps.Icon = await getClusterIcon();
            clusters.push({
              ...asset,
              clusterIcon: icon,
              clusterLabel: asset.totalassets.toString(),
            });
          }
          setAssets([...clusters]);
          // setTimeout(() => {
          //   setAssets(clusters);
          // }, 500);
        } else {
          setAssets(response.data.assets ?? []);
          // setVenues(response.data.venues ?? []);
        }
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorMsg(error);
      });
  };

  const getAssetsInVenue = (venueId: any) => {
    setFetchAssets(false);
    if (!venueId || venueId === '') return;
    setLoading(true);
    ApiHandler({
      apiName: 'assetsInVenue',
      body: {},
      params: { venue_id: venueId, technology_type: getTechnology() },
    })
      .then((response: any) => {
        setAssetSectorIcons(response);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorMsg(error);
      });
  };

  const getAssetsInBuilding = (buildingId: any) => {
    setFetchAssets(false);
    if (!buildingId || buildingId === '') return;
    setLoading(true);
    ApiHandler({
      apiName: 'assetsInBuilding',
      body: {},
      params: { building_id: buildingId, technology_type: getTechnology() },
    })
      .then((response: any) => {
        setAssetSectorIcons(response);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorMsg(error);
      });
  };

  const getAssetsInFloor = (floorId: any) => {
    setFetchAssets(false);
    if (!floorId || floorId === '') return;
    setLoading(true);
    ApiHandler({
      apiName: 'assetsInFloor',
      body: {},
      params: { floor_id: floorId, technology_type: getTechnology() },
    })
      .then(async (response: any) => {
        setAssetSectorIcons(response);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorMsg(error);
      });
  };

  const setAssetSectorIcons = async (response: any) => {
    let assetsWithIcon: any[] = [];
    for (let asset of response.data.assets) {
      let icon: google.maps.Icon = await getMarkerIcon(asset);
      assetsWithIcon.push({
        ...asset,
        markerIcon: icon,
        markerLabel: asset.tracking_id,
      });
    }
    setAssets(assetsWithIcon);
    let buildings: any[] = [];
    console.log('Buildings response: ', response?.data?.buildings);
    if (response?.data?.buildings) {
      for (let building of response?.data?.buildings) {
        buildings.push({
          ...building,
          markerIcon: {
            url: BuildingIcon,
            scaledSize: new google.maps.Size(30, 30),
          },
        });
      }
      setBuildings(buildings);
    } else if (currentPage === 'home') setBuildings([]);
    if (response?.data?.venues?.length > 0) setVenues(response.data.venues);
    // setTimeout(() => {
    //   setAssets(assetsWithIcon);
    // }, 500);
  };

  // useEffect(() => {
  //   console.log('Buildings updated: ', buildings);
  // }, [buildings]);

  const centerUserLocation = (position: any, isLocated: boolean) => {
    if (isLocated) {
      setUserLocation(position);
      // console.log('Centering map to user location: ', position);
      setCenter(position);
      localStorage.setItem('center', JSON.stringify(position));
      map?.setZoom(20);
    }
  };

  const onMapLoad = useCallback(function callback(map: any) {
    setMap(map);
    if (preSelectedAsset) return;
    if (localStorage.getItem('center')) {
      setCenter(JSON.parse(localStorage.getItem('center') ?? '{lat: 39.600292, lng: -104.889944}'));
    } else setUserLocationCenter();
  }, []);
  const onMapUnmount = useCallback(function callback(map: any) {
    setMap(undefined);
  }, []);

  useEffect(() => {
    if (!venueBoundaryPolygon) return;
    if (!venueBoundaryPath || venueBoundaryPath.length < 3) return;
    const path = venueBoundaryPolygon.getPath();
    if (!path) return;

    const updatePath = () => {
      const arr = path.getArray().map((p) => new google.maps.LatLng(p.lat(), p.lng()));
      setVenueBoundaryPath(arr);
    };

    google.maps.event.addListener(path, 'insert_at', updatePath);
    google.maps.event.addListener(path, 'remove_at', updatePath);
    google.maps.event.addListener(path, 'set_at', updatePath);
  }, [venueBoundaryPolygon, venueBoundaryPath]);

  const clickedOnMap = (e: any) => {
    // console.log(venueBoundaryPath, 'Drawing venue boundary, clicked at: ', e.latLng.lat(), e.latLng.lng(), venueBoundaryPolygon);

    if (['addAssetCommon', 'editAsset'].includes(currentPage) && selectedAsset?.asset.status === 'SAS') return;
    if (drawMode === 'draw') {
      const newPath = [...venueBoundaryPath, e.latLng];
      setVenueBoundaryPath(newPath);
      venueBoundaryPolygon?.setPath(newPath);
      return;
    } else if (drawMode === 'draw_emergency') {
      const newPath = [...emergencyBoundaryPath, e.latLng];
      setEmergencyBoundaryPath(newPath);
      emergencyBoundaryPolygon?.setPath(newPath);
      return;
    }
    // if (drawMode === "draw_building") {
    //   buildingBoundaryPolygon?.setPath([...(buildingBoundaryPolygon.getPath()?.getArray() ?? []), e.latLng])
    //   return
    // }
    setAssetDropLocation({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    if (currentPage === 'createRfSimulation' && rfImageUrl === '') {
      setRfLocation({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    }
    setCalculateLocation({ lat: e.latLng.lat().toFixed(6), lng: e.latLng.lng().toFixed(6) });
    setSearchedLocation(false);
    localStorage.setItem('center', JSON.stringify({ lat: e.latLng.lat(), lng: e.latLng.lng() }));
  };

  const addAssetClicked = (title: string, tech: string) => {
    // console.log('Add asset clicked from outdoor map', currentPage, building, currentBuildingId, building?.location);
    if (['buildingDetails', 'venueDetails'].includes(currentPage)) {
      if (currentPage === 'buildingDetails' && building && currentBuildingId) {
        setCurrentBuildingId(building.id);
        setAssetDropLocation(building.location);
      }
    } else setAssetDropLocation(center);
    setSelectedTechnology(getTechnology());
    setTitle(title);
    setCurrentCreateTechnology(tech);
    setCurrentPage('addAssetCommon');
  };

  const addVenueClicked = () => {
    setCurrentPage('addVenue');
    setAssetDropLocation(center);
  };

  const addBuildingClicked = () => {
    setCurrentPage('addBuilding');
    setAssetDropLocation(center);
  };

  const measureClicked = () => {
    setCurrentPage('measure');
  };

  const calculateClicked = () => {
    setCurrentPage('calculate');
    setCalculateLocation({ lat: center.lat.toFixed(6), lng: center.lng.toFixed(6) });
  };

  const changeMapForAzimuth = (isActive: boolean) => {
    setIsAzimuthActive(isActive);
    if (isActive) {
      map?.setZoom(22);
      setCenter(assetDropLocation);
      map?.setOptions({ gestureHandling: 'none' });
    } else {
      map?.setOptions({ gestureHandling: 'auto' });
    }
  };

  const assetClicked = (asset: any) => {
    if (currentPage === 'measure') {
      if (measurePoints.length < 2 && ![null, undefined].includes(asset.tracking_id)) {
        setMeasurePoints([...measurePoints, { lat: parseFloat(asset.latitude), lng: parseFloat(asset.longitude) }]);
        setAssetsForMeasure([...assetsForMeasure, asset.tracking_id]);
        return;
      }
      return;
    }
    let zoomLevel: number | undefined = map?.getZoom();
    if (zoomLevel && zoomLevel <= 13) {
      map?.setZoom(zoomLevel + 1);
      map?.setCenter({ lat: asset.latitude, lng: asset.longitude });
      return;
    }
    setAssetDropLocation({ lat: parseFloat(asset.latitude), lng: parseFloat(asset.longitude) });
    assetInFocus(asset);
  };

  const assetMouseHover = (asset: any) => {
    let zoomLevel: number | undefined = map?.getZoom();
    if (zoomLevel && zoomLevel > 13) {
      setAssetHover(true);
      setHoverData({
        position: { lat: asset.latitude, lng: asset.longitude },
        serialNumber: asset.serial_number,
        trackingId: asset.tracking_id,
        mountingType: asset.mounting_type,
        technologyType: asset.technology_type,
        status: asset?.status,
        cbrsNodeName: asset?.cbrs_node_name,
        vendor_type: asset?.vendor_type,
      });
    }
  };

  const assetInFocus = (asset: any) => {
    map?.setZoom(22);
    setCenter({ lat: parseFloat(asset.latitude), lng: parseFloat(asset.longitude) });
    getSingleAssetDetails(asset.tracking_id);
    localStorage.setItem('center', JSON.stringify({ lat: parseFloat(asset.latitude), lng: parseFloat(asset.longitude) }));
  };

  const getSingleAssetDetails = (trackingId: string) => {
    setLoading(true);
    ApiHandler({ apiName: 'getAsset', body: {}, params: { tracking_id: trackingId } })
      .then((response: any) => {
        setLoading(false);
        const assetData: AssetProps = response.data;
        if (assetData?.relationship && assetData.relationship.length > 0) {
          const bounds = new google.maps.LatLngBounds();

          assetData?.relationship.forEach((pair: any[]) => {
            pair.forEach((point: any) => {
              bounds.extend({ lat: Number(point.lat), lng: Number(point.lng) });
            });
          });
          map?.fitBounds(bounds, {
            left: 400,
            right: 350,
            top: 0,
            bottom: 0,
          });
          // map?.setCenter(map?.getCenter() as google.maps.LatLng);
        }

        if (assetData.base_node_connections && assetData.base_node_connections.length > 0) {
          setViewRFPathAnalysis(true);
          var obstructionsTemp: any[] = [];
          assetData.base_node_connections.map((connection: any) => {
            if (connection?.rf_analysis?.Transmitters?.length > 0 && connection?.rf_analysis?.Transmitters?.[0]?.Obstructions) {
              connection?.rf_analysis?.Transmitters?.[0]?.Obstructions.map((obstruction: any) => {
                obstructionsTemp.push(obstruction);
              });
            }
          });
          setObstructions(obstructionsTemp);
        } else {
          setViewRFPathAnalysis(false);
          setObstructions([]);
        }

        setSelectedAsset(assetData);
        setRFBounds(null);
        setRFImageUrl('');
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorMsg(error);
      });
  };

  const setMarkerIcon = (markerIcon: any, clusterIcon: any, status: any, technologyType: any, trailer: boolean = false) => {
    let wifiIcon: any = {
      url: wifiStatusIcon[status],
      scaledSize: new google.maps.Size(20, 20),
      anchor: new google.maps.Point(8, 8),
      labelOrigin: new google.maps.Point(8, 22),
    };
    let TrailerIcon: any = {
      url: Trailer,
      scaledSize: { width: 20, height: 20 },
      anchor: { x: 0, y: 40 },
      labelOrigin: { x: 0, y: 80 },
    };

    // console.log(markerIcon, 'markerIcon', technologyType, 'technologyType', clusterIcon);
    if (trailer) return TrailerIcon;
    if (markerIcon) {
      if (technologyType === 'wifi_6e') return wifiIcon;
      return markerIcon;
    } else if (clusterIcon) {
      return clusterIcon;
    }
    return {
      url: assetStatusDot[status] ? assetStatusDot[status] : '',
      scaledSize: new google.maps.Size(10, 10),
      anchor: new google.maps.Point(5, 5),
      labelOrigin: new google.maps.Point(5, 10),
    };
  };

  const setMarkerLabel = (markerLabel: any, clusterLabel: any) => {
    // console.log(markerLabel, 'markerlabel');
    if (markerLabel) {
      return {
        text: markerLabel,
        fontFamily: 'Inter',
        fontSize: '10px',
        color: '#000',
      };
    } else if (clusterLabel) {
      return {
        text: clusterLabel,
        fontFamily: 'Inter',
        fontSize: '10px',
        fontWeight: 'bold',
        color: '#fff',
      };
    }
    return '';
  };

  const setDetailsOfMeasure = (info: any) => {
    setMeasureInfo(info);
    setMeasurePopup(true);
  };

  const eraseVenuePolygon = (e: any) => {
    // console.log(venueBoundaryPath, 'Erasing venue boundary point at: ', e.latLng, venueBoundaryPolygon);
    const newPath = venueBoundaryPath.filter((value) => {
      return value.lat() !== e.latLng.lat() || value.lng() !== e.latLng.lng();
    });
    setVenueBoundaryPath(newPath);
    venueBoundaryPolygon?.setPath(newPath);
  };

  const eraseEmergencyPolygon = (e: any) => {
    // console.log(emergencyBoundaryPath, 'Erasing emergency boundary point at: ', e.latLng, emergencyBoundaryPolygon);
    const newPath = emergencyBoundaryPath.filter((value) => {
      return value.lat() !== e.latLng.lat() || value.lng() !== e.latLng.lng();
    });
    setEmergencyBoundaryPath(newPath);
    emergencyBoundaryPolygon?.setPath(newPath);
  };

  const cancelBoundaryDraw = () => {
    setDrawMode(null);
    if (currentPage !== 'editBuilding') {
      venueBoundaryPolygon?.setPath([]);
      setVenueBoundaryPath([]);
    } else {
      // console.log('Cancelling boundary draw in edit building, restoring previous boundary', building, currentBuildingId);

      venueBoundaryPolygon?.setPath(building ? building.polygon_points.map((point: any) => new google.maps.LatLng(point.lat, point.lng)) : []);
      setVenueBoundaryPath(building ? building.polygon_points.map((point: any) => new google.maps.LatLng(point.lat, point.lng)) : []);
      setBuildings([...buildings, building]);
    }
  };

  const setBoundaryDrawMode = (mode: 'draw' | null) => {
    setDrawMode(mode);
    console.log('Setting draw mode to: ', mode, venueBoundaryPolygon, currentBuildingId, buildings, venueBoundaryPath);
    if (mode === 'draw' && venueBoundaryPolygon && currentBuildingId) {
      const currentBuilding = buildings.find((building) => building.id === currentBuildingId);
      setVenueBoundaryPath(currentBuilding ? currentBuilding.polygon_points.map((point: any) => new google.maps.LatLng(point.lat, point.lng)) : []);
      // venueBoundaryPolygon.setPath(
      //   currentBuilding ? currentBuilding.polygon_points.map((point: any) => new google.maps.LatLng(point.lat, point.lng)) : []
      // );
      setBuildings(buildings.filter((building) => building.id !== currentBuildingId));
    }
  };

  const setBuildingsForVenue = (buildings: any) => {
    setCurrentBuildings(buildings);
  };

  useEffect(() => {
    if (venueBoundaryPath.length > 2) {
      let bounds = new google.maps.LatLngBounds();
      venueBoundaryPath.forEach((latLng) => {
        bounds.extend(latLng);
      });
      const center = bounds.getCenter();
      setAssetDropLocation({ lat: center.lat(), lng: center.lng() });
    }
  }, [venueBoundaryPath]);

  const fitVenueOnMap = () => {
    if (map && venueBoundaryPath.length > 0) {
      let bounds = new google.maps.LatLngBounds();
      venueBoundaryPath.forEach((latLng) => {
        bounds.extend(latLng);
      });
      map.fitBounds(bounds);
      fetchAssetsOnIdle();
    }
  };

  const setGeoJSON = (geojSON: any) => {
    map?.data.addGeoJson(geojSON);
    map?.data.setStyle({
      strokeWeight: 1,
      fillOpacity: 0.7,
      fillColor: '#0059b2', //"#ff9444",
      strokeColor: '#0059b2',
    });
  };

  const getBuildingPolygons = (lat: number, lng: number) => {
    ApiHandler({ apiName: 'getOneGeo', body: { latitude: lat, longitude: lng }, params: {} })
      .then((response: any) => {
        // Convert data to polygons
        if (!response) return;
        map?.data.addGeoJson(response?.data?.data);
        map?.data.setStyle({
          strokeWeight: 1,
          fillOpacity: 0.4,
          fillColor: '#0059b2', //"#ff9444",
          strokeColor: '#0059b2',
        });
      })
      .catch((error: any) => {
        setErrorAlert(true);
        setErrorMessage(error?.message ?? 'Could not get building boundaries');
      });
  };

  const setGeoJSONUrl = (url: any) => {
    map?.data.loadGeoJson(url);
    map?.data.setStyle({
      strokeWeight: 1,
      fillOpacity: 1,
      fillColor: '#cccccc',
      strokeColor: '#aaaaaa',
    });
    setFloorPlanGeometry(url);
  };

  const unsetGeoJSON = () => {
    setFloorPlanGeometry(null);
    // map?.data.forEach((feature) => {
    //   map.data.remove(feature);
    // });
  };

  const changeMapAssetFilter = (val: string) => {
    var tempFilterList = mapAssetFilters;
    const isExist = tempFilterList.find((item) => item == val);
    // console.log(mapAssetFilters, 'mapAssetFilters', val, isExist);
    if (isExist) tempFilterList = tempFilterList.filter((item) => item !== val);
    else tempFilterList = [...tempFilterList, val];
    getAssetsInBounds(map, tempFilterList);
    setMapAssetFilters(tempFilterList);
  };

  const startRFAnalysis = (asset_id: string) => {
    if (asset_id) {
      setLoading(true);
      ApiHandler({
        apiName: 'getRFData',
        body: {},
        params: { tracking_id: asset_id },
      })
        .then(async (response: any) => {
          if (response) {
            // console.log(response, 'getrfdata');

            setRFBounds(response['data']['bounds']);
            setRFImageUrl(response['data']['image']);
            map?.setZoom(17);

            const loc = {
              lat: selectedAsset?.asset?.latitude as number,
              lng: selectedAsset?.asset?.longitude as number,
            };
            setAssetDropLocation(loc);
            setCurrentPage('cpePreloaded');

            setLoading(false);
          }
        })
        .catch((error: any) => {
          setLoading(false);
          setErrorMsg(error);
        });
      // const imageUrl = 'https://api.cloudrf.com/output/projection/3857/68188/0711053016_Testing_A1.png';
      // const bounds = {
      //   north: 39.6482,
      //   south: 39.5782,
      //   east: -104.836,
      //   west: -104.906,
      // };
    }
  };

  const runMultipleRFAnalysis = () => {
    setLoading(true);
    const technology = getTechnology();
    console.log(assetDropLocation, 'assetDropLocation');
    if (!assetDropLocation || (assetDropLocation.lat === 0 && assetDropLocation.lng === 0)) {
      setLoading(false);
      setErrorAlert(true);
      setErrorMessage('Please select an estimated location on the map using the pin');
      return;
    }

    ApiHandler({
      apiName: 'runMultipleRFAnalysis',
      body: {
        latitude: assetDropLocation.lat,
        longitude: assetDropLocation.lng,
        technology: technology,
        ...rfAnalysisForm,
      },
      params: {},
    })
      .then(async (response: any) => {
        setLoading(false);
        if (response) {
          setRFBounds(response['data']['bounds']);
          setRFImageUrl(response['data']['rf_png']);
          setRfParameters(response['data']['rf_parameters']);
          setRfResults(response['data']['rf_results']);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorAlert(true);
        console.log(error, 'error');
        setErrorMessage(error?.data?.message ?? error?.message ?? 'Could not run RF Analysis');
      });
  };

  const getTechnologyMapping = (type: string) => {
    switch (type) {
      case 'tarana':
        return 'tarana_cpe';
      case 'cbrs_5g':
        return 'cpe_cbsd';
      case 'wifi_6e':
        return 'cpe_wifi';
    }
  };

  const addSiteToWorkOrder = () => {
    setLoading(true);
    var reqBody: any = {
      location: assetDropLocation,
      technology_type: getTechnologyMapping(getTechnology()),
      work_order_id: workOrderId,
      work_order_type: 'service_drop',
      rf_parameters: rfParameters,
      rf_results: rfResults,
      rf_image_path: rfImageUrl,
      venue_id: workOrderVenueId ? workOrderVenueId : null,
      building_id: workOrderBuildingId ? workOrderBuildingId : null,
    };
    if (isEmergency) {
      reqBody['work_order_type'] = 'emergency';
    }
    ApiHandler({
      apiName: 'createWorkOrder',
      body: reqBody,
      params: {},
    })
      .then(async (response: any) => {
        if (response) {
          getAssetsInBounds(map);
          setTotalServiceDrops((prev) => [...prev, response?.data]);
          setIsPlacingWorkOrder(false);
        }
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        setErrorMsg(error);
        setLoading(false);
      });
  };

  const cancelWorkOrderCreation = () => {
    setCurrentPage('viewWorkOrders');
    setWorkOrderId('');
    setTotalServiceDrops([]);
    setRFBounds(null);
    setRFImageUrl('');
    setIsEmergency(false);
    setIsPlacingWorkOrder(false);
    setDrawMode(null);
    setEmergencyBoundaryPath([]);
    setEmergencyBoundaryPolygon(undefined);
  };

  const cancelRfSimulation = () => {
    setCurrentPage('home');
    setRFBounds(null);
    setRFImageUrl('');
    setRfParameters({});
    setRfResults({});
    setRfAnalysisForm({
      internal_radius: 1000,
      simulation_provider: 'cloudrf',
      radius: 10000,
      receiver_height: 6,
      receiver_gain: 18.5,
      receiver_sensitivity: -100,
      pm: 1,
      pe: 2,
      ked: 1,
      rel: 90,
      rcs: 1,
      elevation: 2,
      landcover: 1,
      buildings: 1,
      obstacles: 1,
    });
    setShowRfRadius(true);
    setShowRfAnalysis(true);
    setRfLocation({ lat: 0, lng: 0 });
  };

  const showRfSimulations = () => {
    setCurrentPage('viewRfSimulation');
    setRFBounds(null);
    setRFImageUrl('');
    setRfParameters({});
    setRfResults({});
    setRfAnalysisForm({
      internal_radius: 1000,
      simulation_provider: 'cloudrf',
      radius: 10000,
      receiver_height: 6,
      receiver_gain: 18.5,
      receiver_sensitivity: -100,
      pm: 1,
      pe: 2,
      ked: 1,
      rel: 90,
      rcs: 1,
      elevation: 2,
      landcover: 1,
      buildings: 1,
      obstacles: 1,
    });
    setShowRfRadius(true);
    setShowRfAnalysis(true);
    setRfLocation({ lat: 0, lng: 0 });
  };

  // const boundsImage = {
  //   north: 39.60231666666667,
  //   south: 39.60172222222222,
  //   east: -104.8898638888889,
  //   west: -104.8907083333333,
  // };
  // const boundsImage = {
  //   north: 39.602305,
  //   south: 39.601713,
  //   east: -104.889886,
  //   west: -104.890678,
  // };

  // const userBounds = {
  //   north: 39.60230309110386,
  //   south: 39.60172018188547,
  //   east: -104.88989169308272,
  //   west: -104.89067123575899,
  // };

  const getFloorNumber = (floor_number: number) => {
    var retVal = '02';
    if (floor_number.toString().length < 2) retVal = 0 + floor_number.toString();
    else retVal = floor_number.toString();
    return retVal;
  };

  const getFloorImage = (floor_detail: any) => {
    console.log('floorPlanImage', floor_detail);
    if (floor_detail?.id) {
      setLoading(true);
      var requestBody: any = { floor_id: floor_detail?.id };
      ApiHandler({
        apiName: 'getFloorPlanImage',
        body: {},
        params: requestBody,
      })
        .then((response: any) => {
          if (response) {
            // console.log(response, 'Responseeeeeee');
            setFloorPlan(response?.data?.url);
            setImageRotation(response?.data?.bearing);
            // console.log(getUnrotatedBoundsPrecise(response?.data?.bounds?.polygon, response?.data?.bearing), 'consoejshdisauh');

            // setImageBounds(
            //   getUnrotatedBoundsPrecise(
            //     [
            //       { lat: 39.60246065639882, lng: -104.89034092798849 },
            //       { lat: 39.6018864798379, lng: -104.8898856933509 },
            //       { lat: 39.60169403284115, lng: -104.89029456441435 },
            //       { lat: 39.60226821099792, lng: -104.89074979905186 },
            //     ],
            //     response?.data?.bearing
            //   )
            // );
            // setImageBounds({ northEast: response?.data?.bounds?.northEast, southWest: response?.data?.bounds?.southWest });
            // (response?.data?.bounds?.cardinal);
            setImageBounds(response?.data?.bounds?.polygon);
            setFloorGeometries(response?.data?.floor_plan_geom?.geometries[0] ? [response?.data?.floor_plan_geom?.geometries[0]] : []);
            setLoading(false);
          }
        })
        .catch((error: any) => {
          setFloorPlan('');
          setImageBounds([]);
          setErrorMessage(error?.message ?? 'Something went wrong');
          console.error('Error fetching floor plan.', error);
          setLoading(false);
        });
    }
  };

  const newBounds = {
    north: 39.602460484271425,
    south: 39.60169420436785,
    east: -104.88991314026606,
    west: -104.89072235069598,
  };

  const getMountingTypeName: any = {
    Aerial: 'Strand',
    ROE: 'Macro',
    SMB: 'SMB',
  };

  const downloadImage = () => {
    try {
      saveAs(viewImage.image, `${selectedAsset?.asset.tracking_id}_${viewImage.fileName}`);
    } catch (error: any) {
      console.info(error);
    }
  };

  return isLoaded ? (
    <GoogleMap
      onClick={clickedOnMap}
      mapContainerStyle={mapStyle}
      center={center}
      zoom={15}
      onTilesLoaded={() => {
        if (!mapTilesLoaded) {
          setMapTilesLoaded(true);
        }
      }}
      onLoad={onMapLoad}
      onUnmount={onMapUnmount}
      options={mapOptions}
      clickableIcons={false}
      onDragEnd={() => {
        setCenter({
          lat: map?.getCenter()?.lat() || 0,
          lng: map?.getCenter()?.lng() ?? 0,
        });
        if (currentPage === 'createRfSimulation') {
          getNodesInRadius(rfLocation, rfAnalysisForm.internal_radius, getTechnology());
        } else {
          setFetchAssets(true);
        }

        localStorage.setItem(
          'center',
          JSON.stringify({
            lat: map?.getCenter()?.lat(),
            lng: map?.getCenter()?.lng(),
          })
        );
      }}
      onZoomChanged={() => {
        const zoom: any = map?.getZoom();
        if (zoom) {
          localStorage.setItem('zoom', zoom.toString());
        }
        if (currentPage === 'createRfSimulation') {
          getNodesInRadius(rfLocation, rfAnalysisForm.internal_radius, getTechnology());
        } else {
          setFetchAssets(true);
        }
      }}>
      {rfBounds && rfImageUrl && mapManagerRfDisplay && showRfAnalysis ? (
        <RFImageOverlay bounds={rfBounds} imageUrl={rfImageUrl} map={map as google.maps.Map} />
      ) : (
        <></>
      )}
      {/* <KmlLayer
        url="https://api.cloudrf.com/archive/S0R3eGZhL0NrUHpXUDU4NlEwejRMUT09/kmz" // Replace with the URL of your KML file
        options={{
          preserveViewport: true, // Optional: prevents the map from adjusting its viewport to fit the KML layer
        }}
      /> */}

      {/* <KmlLayer
        url={`${window.location.origin}/spectrum_plaza_02.kmz`}
        options={{
          preserveViewport: true, // Optional: prevents the map from adjusting its viewport to fit the KML layer
          map: map,
        }}
      /> */}

      {selectedFloor?.floor_number && ['buildingDetails', 'addAssetCommon', 'editAsset'].includes(currentPage) && imageBounds && floorPlan && (
        <>
          <ImageOverlay
            imageUrl={floorPlan}
            map={map as google.maps.Map}
            opacity=".5"
            // northEast={imageBounds['northEast']}
            // southWest={imageBounds['southWest']}
            polygon={imageBounds}
            rotation={imageRotation}
          />
        </>
      )}

      {mapManagerConnectivityDisplay &&
        mapManagerAssetGroupsDisplay &&
        selectedAsset?.relationship?.map((relation: any, index: number) => {
          const getCenter = getLineCenter(relation[0], relation[1]);
          return (
            <>
              <Polyline
                key={index + 'relation'}
                path={relation.map((point: any) => ({ lat: point.lat, lng: point.lng }))}
                options={{
                  strokeColor: getSignalStrengthColor(relation[0].signal_strength),
                  strokeWeight: 2,
                  clickable: false,
                  strokeOpacity: 0,
                  zIndex: 1,
                  icons: [
                    {
                      icon: {
                        path: 'M 0,-1 0,1',
                        strokeOpacity: 1,
                        scale: 2,
                      },
                      offset: '0',
                      repeat: '10px',
                    },
                  ],
                }}
              />
              <Marker
                key={index + 'relation_marker'}
                position={{ lat: getCenter.lat, lng: getCenter.lng }}
                icon={{
                  url: PillIcon,
                  scaledSize: new google.maps.Size(60, 60),
                  anchor: new google.maps.Point(30, 30),
                }}
                label={{
                  text: relation[0].signal_strength ? `${relation[0].signal_strength} dBm` : '',
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  color: '#000',
                }}
                clickable={false}
              />
            </>
          );
        })}

      {floorGeometries.length > 0 &&
        selectedFloor?.floor_number &&
        !['home', 'addAssetCommon', 'editAsset'].includes(currentPage) &&
        floorGeometries.map((geometry: any, index: number) => {
          if (geometry.type === 'Polygon') {
            return (
              <>
                <Polygon
                  key={index + 'floor_polygon'}
                  paths={geometry.coordinates[0].map((coord: any) => ({ lat: coord[1], lng: coord[0] }))}
                  options={{
                    strokeColor: '#0059b2',
                    strokeOpacity: 1,
                    strokeWeight: 1,
                    fillColor: 'transparent',
                    clickable: false,
                    zIndex: 1,
                  }}
                />
              </>
            );
          } else if (geometry?.type === 'LineString') {
            return (
              <Polyline
                key={index + 'floor_linestring'}
                path={geometry.coordinates.map((coord: any) => coord)}
                options={{
                  strokeColor: '#0059b2',
                  strokeOpacity: 1,
                  strokeWeight: 2,
                  clickable: false,
                  zIndex: 1,
                }}
              />
            );
          } else {
            return null;
          }
        })}

      <OutdoorRoutes
        cancelEmergencyDrawing={() => {
          setDrawMode(null);
          setEmergencyBoundaryPath([]);
          setEmergencyBoundaryPolygon(undefined);
        }}
        setDrawMode={setDrawMode}
        drawMode={drawMode}
        isEmergency={isEmergency}
        setRFImageUrl={setRFImageUrl}
        setRFBounds={setRFBounds}
        isPlacingWorkOrder={isPlacingWorkOrder}
        totalServiceDrops={totalServiceDrops}
        setTotalServiceDrops={setTotalServiceDrops}
        setIsPlacingWorkOrder={setIsPlacingWorkOrder}
        assets={assets}
        setRfResults={setRfResults}
        setRfParameters={setRfParameters}
        setRfImageUrl={setRFImageUrl}
        setRfBounds={setRFBounds}
        rfResults={rfResults}
        rfParameters={rfParameters}
        rfImageUrl={rfImageUrl}
        rfBounds={rfBounds}
        rfLocation={rfLocation}
        cancelRfSimulation={cancelRfSimulation}
        showRfSimulations={showRfSimulations}
        setWorkOrderId={setWorkOrderId}
        setRfLocation={setRfLocation}
        showRfRadius={showRfRadius}
        setShowRfRadius={setShowRfRadius}
        showRfAnalysis={showRfAnalysis}
        setShowRfAnalysis={setShowRfAnalysis}
        rfAnalysisForm={rfAnalysisForm}
        setRfAnalysisForm={setRfAnalysisForm}
        runMultipleRFAnalysis={runMultipleRFAnalysis}
        getBuildingPolygons={getBuildingPolygons}
        addAssetClicked={addAssetClicked}
        addVenueClicked={addVenueClicked}
        addBuildingClicked={addBuildingClicked}
        assetDropLocation={assetDropLocation}
        assetEditAction={assetEditAction}
        assetsForMeasure={assetsForMeasure}
        calculateClicked={calculateClicked}
        calculateLocation={calculateLocation}
        center={center}
        changeMapForAzimuth={changeMapForAzimuth}
        currentPage={currentPage}
        getAssetsInBounds={(map: any) => {
          setAssets([]);
          setFetchAssets(true);
        }}
        getSingleAssetDetails={getSingleAssetDetails}
        goToProfile={goToProfile}
        map={map}
        measureClicked={measureClicked}
        measurePoints={measurePoints}
        rmaNewSerialNumber={rmaNewSerialNumber}
        selectedAsset={selectedAsset}
        setAssetDropLocation={setAssetDropLocation}
        setAssetEditAction={setAssetEditAction}
        setCalculateLocation={setCalculateLocation}
        setCenter={setCenter}
        setCurrentPage={setCurrentPage}
        setDetailsOfMeasure={setDetailsOfMeasure}
        setMeasurePoints={setMeasurePoints}
        setRmaNewSerialNumber={setRmaNewSerialNumber}
        setSelectedAsset={setSelectedAsset}
        showMeasurePopup={setMeasurePopup}
        showSearchLocation={setSearchedLocation}
        boundaryPolygon={venueBoundaryPath}
        emergencyBoundaryPolygon={emergencyBoundaryPath}
        cancelBoundaryDraw={cancelBoundaryDraw}
        // setBoundaryColor={setBoundaryColor}
        setBoundaryDrawMode={setBoundaryDrawMode}
        // boundaryColor={venueBoundaryColor}
        setCurrentVenueId={(venueId: string) => {
          setCurrentVenueId(venueId);
        }}
        venueId={currentVenueId}
        setBuildingsForVenue={setBuildingsForVenue}
        setBuildingId={(buildingId: string) => {
          setCurrentBuildingId(buildingId);
        }}
        buildingId={currentBuildingId}
        setFloorId={(floorId: string) => {
          setCurrentFloorId(floorId);
        }}
        floorId={currentFloorId}
        venuesOnMap={venues}
        assetsInBounds={assets}
        fitVenueOnMap={fitVenueOnMap}
        setFloorGeoJSON={(geoJSON: any) => {
          setGeoJSON(geoJSON);
        }}
        setFloorGeoJSONUrl={(url: any) => {
          setGeoJSONUrl(url);
        }}
        panToBuilding={panToBuilding}
        unsetFloorGeoJSON={unsetGeoJSON}
        setShowControls={setShowControls}
        getRFAnalysis={(asset_id) => startRFAnalysis(asset_id)}
        addSiteToWorkOrder={addSiteToWorkOrder}
        cancelWorkOrderCreation={cancelWorkOrderCreation}
        mapAssetFilters={mapAssetFilters}
        changeMapAssetFilter={changeMapAssetFilter}
        setIsEmergency={setIsEmergency}
        setSelectedFloor={(selectedFloor) => {
          console.log('Selected floor:', selectedFloor);
          setSelectedFloor(selectedFloor);
          getAssetsInFloor(selectedFloor?.id);
          getFloorImage(selectedFloor);
        }}
        selectedFloor={selectedFloor}
        selectedTechnology={selectedTechnology}
        title={title}
        currentSelectedTechnology={currentCreateTechnology}
        buildingsOnMap={buildings}
        building={building}
        setBuilding={setBuilding}
        setVenueBoundaryPath={setVenueBoundaryPath}
        setHiddenVenueId={setHiddenVenueId}
        setWorkOrderBuildingId={setWorkOrderBuildingId}
        setWorkOrderVenueId={setWorkOrderVenueId}
        viewRFPathAnalysis={viewRFPathAnalysis}
        setViewRFPathAnalysis={setViewRFPathAnalysis}
        setShowActionPanel={setShowActionPanel}
        showActionPanel={showActionPanel}
      />

      {showControls && (
        <>
          <div
            className={
              'position-fixed col-wise ' +
              (['home', 'workOrderCreation', 'viewRfSimulation', 'viewWorkOrders'].includes(currentPage)
                ? 'position-right-actions '
                : currentPage == 'assetDetails' && !showActionPanel
                ? 'position-right-actions '
                : // : getTechnology() == 'wifi_6e'
                // ? 'shift-down shifted-position-right-actions '
                currentPage == 'assetDetails'
                ? ' shifted-position-right-actions-details '
                : ' shifted-position-right-actions ')
            }>
            <div className="d-flex row-wise align-items-start ">
              <Collapse
                bordered={false}
                className="rounded-3"
                expandIconPosition="end"
                style={{ backgroundColor: '#F5F5F5', marginRight: '1rem', borderRadius: '8px', width: '250px' }}
                items={[
                  {
                    key: '1_map-manager',
                    label: <label>Map manager</label>,
                    headerClass: 'map-manager-header',
                    style: {
                      backgroundColor: '#F5F5F5',
                      borderRadius: '8px',
                      border: '1px solid #0000000f',
                      padding: '6px 12px !important',
                    },
                    children: (
                      <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 150px)' }}>
                        <Divider style={{ marginTop: '-6px' }} className="mb-3" />
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Title level={5} className="mb-0" style={{ fontSize: '14px' }}>
                            Map Base Layers
                          </Typography.Title>
                        </div>
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Text className="d-flex align-items-center">
                            <img
                              src={SatelliteMap}
                              height={20}
                              width={20}
                              alt="Satellite"
                              className="me-2"
                              style={{ border: '1px solid #0000001f', borderRadius: '4px', padding: '1px' }}
                            />
                            Satellite
                          </Typography.Text>
                          <Checkbox
                            checked={mapManagerMapDisplay === 'HYBRID'}
                            onChange={(e) => {
                              if (e.target.checked) setMapManagerMapDisplay('HYBRID');
                              map?.setMapTypeId(google.maps.MapTypeId.HYBRID);
                            }}
                          />
                        </div>
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Text className="d-flex align-items-center">
                            <img
                              src={DefaultMap}
                              height={20}
                              width={20}
                              alt="Roadmap"
                              className="me-2"
                              style={{ border: '1px solid #0000001f', borderRadius: '4px', padding: '1px' }}
                            />
                            Roadmap
                          </Typography.Text>
                          <Checkbox
                            checked={mapManagerMapDisplay === 'ROADMAP'}
                            onChange={(e) => {
                              if (e.target.checked) setMapManagerMapDisplay('ROADMAP');
                              map?.setMapTypeId(google.maps.MapTypeId.ROADMAP);
                            }}
                          />
                        </div>
                        <Divider className="my-3" />
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Title level={5} className="mb-0" style={{ fontSize: '14px' }}>
                            Assets
                          </Typography.Title>
                          <Switch
                            size="small"
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            defaultChecked
                            onChange={(e) => setMapManagerShowAllAsset(e)}
                          />
                        </div>
                        {legendTechDisplay.map((tech: any, index) => {
                          return (
                            <div key={tech + 'legend_teh' + indexedDB + index} className="justify-content-between d-flex align-items-center mb-2">
                              <Typography.Text>{tech.label}</Typography.Text>
                              <Checkbox
                                disabled={!mapManagerShowAllAsset}
                                checked={mapAssetFilters.includes(tech['value'])}
                                onChange={() => changeMapAssetFilter(tech['value'])}
                              />
                            </div>
                          );
                        })}
                        <Divider className="my-3" />
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Title level={5} className="mb-0" style={{ fontSize: '14px' }}>
                            Boundary Layers
                          </Typography.Title>
                          <Switch
                            size="small"
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            defaultChecked
                            onChange={(e) => setMapManagerShowAllLayers(e)}
                          />
                        </div>
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <div className="d-flex align-items-center flex-row gap-2">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ width: '20px', height: '20px', borderRadius: '4px', border: '1px solid #1D68D1', padding: '3px' }}>
                              <div style={{ backgroundColor: '#1D68D1', width: '100%', height: '2px' }}></div>
                            </div>
                            <Typography.Text>Venue</Typography.Text>
                          </div>
                          <Checkbox
                            disabled={!mapManagerShowAllLayers}
                            checked={mapManagerVenueDisplay}
                            onChange={() => {
                              setMapManagerVenueDisplay(!mapManagerVenueDisplay);
                            }}
                          />
                        </div>
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <div className="d-flex align-items-center flex-row gap-2">
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ width: '20px', height: '20px', borderRadius: '4px', border: '1px solid #1DD14F', padding: '3px' }}>
                              <div style={{ backgroundColor: '#1DD14F', width: '100%', height: '2px' }}></div>
                            </div>
                            <Typography.Text>Building</Typography.Text>
                          </div>
                          <Checkbox
                            disabled={!mapManagerShowAllLayers}
                            checked={mapManagerBuildingDisplay}
                            onChange={() => {
                              setMapManagerBuildingDisplay(!mapManagerBuildingDisplay);
                            }}
                          />
                        </div>
                        <Divider className="my-3" />
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Title level={5} className="mb-0" style={{ fontSize: '14px' }}>
                            RF Layers
                          </Typography.Title>
                          <Switch
                            size="small"
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            defaultChecked
                            onChange={(e) => setMapManagerRFDisplay(e)}
                          />
                        </div>
                        <Divider className="my-3" />
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Title level={5} className="mb-0" style={{ fontSize: '14px' }}>
                            Connectivity Layers
                          </Typography.Title>
                          <Switch
                            size="small"
                            checkedChildren={<CheckOutlined />}
                            unCheckedChildren={<CloseOutlined />}
                            defaultChecked
                            onChange={(e) => setMapManagerConnectivityDisplay(e)}
                          />
                        </div>
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Text className="d-flex align-items-center">
                            <div
                              style={{
                                border: '1px solid #1677ff ',
                                color: '#1677ff',
                                padding: '0 2px',
                                display: 'flex',
                                height: '20px',
                                width: '20px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: '4px',
                              }}
                              className="me-2">
                              --
                            </div>
                            Asset Group
                          </Typography.Text>
                          <Checkbox
                            disabled={!mapManagerConnectivityDisplay}
                            checked={mapManagerAssetGroupsDisplay}
                            onChange={() => {
                              setMapManagerAssetGroupsDisplay(!mapManagerAssetGroupsDisplay);
                            }}
                          />
                        </div>
                        <div className="justify-content-between d-flex align-items-center mb-2">
                          <Typography.Text className="d-flex align-items-center">
                            <img src={ObstructionIcon} height={16} width={16} alt="Obstructions" className="me-2" />
                            Obstructions
                          </Typography.Text>
                          <Checkbox
                            disabled={!mapManagerConnectivityDisplay}
                            checked={mapManagerObstructionsDisplay}
                            onChange={() => {
                              setMapManagerObstructionsDisplay(!mapManagerObstructionsDisplay);
                            }}
                          />
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
              <div>
                <LocateMe
                  located={(coordinates: any, found: boolean) => {
                    centerUserLocation(coordinates, found);
                  }}
                  error={(error: any) => {
                    setErrorMessage(error.message);
                    setErrorAlert(error.alert);
                  }}
                />{' '}
                <AssetLegend />
              </div>
            </div>
            {/*  <ToggleMapType
              change={() => {
                map?.getMapTypeId() === google.maps.MapTypeId.ROADMAP
                  ? map?.setMapTypeId(google.maps.MapTypeId.HYBRID)
                  : map?.setMapTypeId(google.maps.MapTypeId.ROADMAP);
              }}
            /> */}
          </div>

          {rfResults?.key && (
            <div className="position-fixed" style={{ top: '50%', left: 'calc(1.3rem + 390px)', transform: 'translateY(-50%)' }}>
              <RFLegend legend={rfResults?.key} />
            </div>
          )}
          <div
            className={
              'position-fixed col-wise ' +
              (['home', 'workOrderCreation', 'viewRfSimulation', 'viewWorkOrders'].includes(currentPage)
                ? 'position-zoom-actions '
                : currentPage == 'assetDetails' && !showActionPanel
                ? 'position-zoom-actions '
                : currentPage == 'assetDetails'
                ? ' shifted-position-zoom-actions-details '
                : 'shifted-position-zoom-actions ')
            }>
            <ZoomPlus
              map={map}
              clicked={(currentZoom: number) => {
                console.log('currentZoom', currentZoom + 1);
                map?.setZoom(currentZoom + 1);
              }}
            />
            <ZoomMinus
              map={map}
              clicked={(currentZoom: number) => {
                console.log('currentZoom', currentZoom - 1);
                map?.setZoom(currentZoom - 1);
              }}
            />
          </div>
        </>
      )}
      {assets &&
        mapManagerShowAllAsset &&
        assets.map((asset: any) => {
          return (
            <div key={asset.tracking_id + 'marker'}>
              <Marker
                key={asset.tracking_id}
                icon={setMarkerIcon(asset?.markerIcon, asset?.clusterIcon, asset?.status, asset?.technology_type)}
                label={asset?.job_type !== 'emergency' ? setMarkerLabel(asset?.markerLabel, asset?.clusterLabel) : undefined}
                onMouseOver={() => {
                  assetMouseHover(asset);
                }}
                onMouseOut={() => {
                  setAssetHover(false);
                }}
                position={{
                  lat: parseFloat(asset.latitude),
                  lng: parseFloat(asset.longitude),
                }}
                onClick={() => {
                  if (viewRFPathAnalysis) {
                    const latExist = selectedAsset?.base_node_connections?.find(
                      (connection) => connection.rf_analysis?.Receiver?.[0]?.['Latitude']?.toFixed(4) == +asset.latitude.toFixed(4)
                    );
                    const lngExist = selectedAsset?.base_node_connections?.find(
                      (connection) => connection.rf_analysis?.Receiver?.[0]?.['Longitude']?.toFixed(4) == +asset.longitude.toFixed(4)
                    );
                    if (latExist && lngExist) {
                      setViewImage({
                        image: latExist?.rf_analysis?.['Chart image'] as string,
                        fileName: latExist?.rf_analysis?.['Chart image'].slice(latExist?.rf_analysis?.['Chart image'].lastIndexOf('/') + 1) as string,
                        popup: true,
                        path: latExist?.rf_analysis?.['Chart image'] as string,
                      });
                    }
                    return;
                  }
                  if (isPlacingWorkOrder) {
                    setAssetDropLocation({ lat: asset.latitude ?? 0, lng: asset.longitude ?? 0 });
                  }
                  if (!['viewRfSimulation', 'createRfSimulation', 'viewWorkOrders', 'createWorkOrder'].includes(currentPage)) {
                    assetClicked(asset);
                  }
                }}
                draggable={false}
                options={{ map: map }}
              />
              {asset?.job_type == 'emergency' && (
                <Marker
                  key={asset.tracking_id + 'emergency'}
                  icon={setMarkerIcon(asset?.markerIcon, asset?.clusterIcon, asset?.status, asset?.technology_type, true)}
                  label={setMarkerLabel(asset?.markerLabel, asset?.clusterLabel)}
                  onMouseOver={() => {
                    assetMouseHover(asset);
                  }}
                  onMouseOut={() => {
                    setAssetHover(false);
                  }}
                  position={{
                    lat: parseFloat(asset.latitude),
                    lng: parseFloat(asset.longitude),
                  }}
                  onClick={() => {
                    if (isPlacingWorkOrder) {
                      setAssetDropLocation({ lat: asset.latitude ?? 0, lng: asset.longitude ?? 0 });
                    }
                    assetClicked(asset);
                  }}
                  draggable={false}
                  options={{ map: map }}
                />
              )}
            </div>
          );
        })}

      {/* Locations of existing buildings from bounds API */}

      {buildings &&
        mapManagerBuildingDisplay &&
        mapManagerShowAllLayers &&
        floorGeometries.length === 0 &&
        buildings.map((building: any) => {
          return (
            <div key={building?.id + 'building_marker'}>
              {/* <Marker
                key={building?.id}
                position={building.location}
                // visible={(![null, ''].includes(currentVenueId) || ![null, ''].includes(currentBuildingId)) && [null, ''].includes(currentFloorId)}
                icon={{
                  url: BuildingIcon,
                  scale: 1,
                  anchor: new google.maps.Point(10, 10),
                  scaledSize: new google.maps.Size(20, 20),
                }}
                onClick={(e) => {
                  if (['editAsset', 'addAssetCommon'].includes(currentPage)) {
                    setAssetDropLocation({ lat: e?.latLng?.lat() ?? 0, lng: e.latLng?.lng() ?? 0 });
                    return;
                  }
                  setCurrentBuildingId(building.id);
                  setCurrentPage('buildingDetails');
                }}
              /> */}
              {building?.polygon_points?.length > 0 && (
                <Polygon
                  key={building?.id + 'building_polygon'}
                  paths={building.polygon_points}
                  options={{
                    strokeColor: '#1DD14F',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#1DD14F',
                    fillOpacity: 0.1,
                    clickable: true,
                    zIndex: 1,
                  }}
                  onClick={(e) => {
                    if (['editAsset', 'addAssetCommon'].includes(currentPage) || isPlacingWorkOrder) {
                      setAssetDropLocation({ lat: e?.latLng?.lat() ?? 0, lng: e.latLng?.lng() ?? 0 });
                      return;
                    }
                    setCurrentBuildingId(building.id);
                    setCurrentPage('buildingDetails');
                  }}
                />
              )}
            </div>
          );
        })}
      {measurePoints &&
        measurePoints.map((point: any, index: number) => {
          return (
            <Marker
              icon={AssetDropIcon}
              key={point.lat + point.lng + index}
              position={{
                lat: parseFloat(point.lat),
                lng: parseFloat(point.lng),
              }}
              clickable={false}
              draggable={false}
            />
          );
        })}

      {measurePoints && measurePoints.length > 1 && (
        <Polyline
          options={{
            icons: [
              {
                icon: {
                  path: 'M 0,-1 0,1',
                  scale: 4,
                  strokeColor: '#FF9445',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: '#FF9445',
                  fillOpacity: 0.35,
                },
                offset: '0',
                repeat: '20px',
              },
            ],
            strokeColor: '#FF9445',
            strokeOpacity: 0,
            strokeWeight: 2,
            clickable: false,
            draggable: false,
            editable: false,
            visible: true,
            zIndex: 1,
          }}
          path={measurePoints}
        />
      )}

      {/* Polygon used for creating venue */}

      <Polygon
        paths={venueBoundaryPath}
        onLoad={(polygon) => {
          console.log('Venue boundary polygon loaded:', polygon);
          setVenueBoundaryPolygon(polygon);
          const path = polygon.getPath();
          if (path) {
            google.maps.event.addListener(path, 'insert_at', () => {
              console.log('insert_at called');
              setVenueBoundaryPath(path.getArray());
            });
            google.maps.event.addListener(path, 'remove_at', () => {
              console.log('remove_at called');
              setVenueBoundaryPath(path.getArray());
            });
            google.maps.event.addListener(path, 'set_at', () => {
              console.log('set_at called');
              setVenueBoundaryPath(path.getArray());
            });
          }
        }}
        onClick={eraseVenuePolygon}
        options={{
          strokeColor: '#0059b2',
          fillColor: drawMode === null ? 'transparent' : '#0059b2',
          fillOpacity: 0.15,
          editable: drawMode !== null,
          strokeWeight: 1,
          zIndex: 2,
        }}
      />

      <Polygon
        paths={emergencyBoundaryPath}
        onLoad={(polygon) => {
          setEmergencyBoundaryPolygon(polygon);
          const path = polygon.getPath();
          if (path) {
            google.maps.event.addListener(path, 'insert_at', () => {
              setEmergencyBoundaryPath(path.getArray());
            });
            google.maps.event.addListener(path, 'remove_at', () => {
              setEmergencyBoundaryPath(path.getArray());
            });
            google.maps.event.addListener(path, 'set_at', () => {
              setEmergencyBoundaryPath(path.getArray());
            });
          }
        }}
        onClick={eraseEmergencyPolygon}
        options={{
          strokeColor: '#FF0000',
          fillColor: '#FF0000',
          fillOpacity: 0.1,
          editable: drawMode !== null,
          strokeWeight: 2,
          zIndex: 2,
        }}
      />

      {/* Polygons of existing venues */}
      {venues &&
        mapManagerVenueDisplay &&
        mapManagerShowAllLayers &&
        // currentPage !== 'buildingDetails' &&
        !floorPlanGeometry &&
        map?.getZoom() &&
        venues.map((venue: any) => {
          if (venue.polygon === undefined) return;
          if (venue.id === hiddenVenueId) return;
          // when zoomed in, show all venue polygons
          return (
            <Polygon
              paths={venue.polygon}
              options={{
                strokeWeight: 2,
                fillOpacity: 0.1,
                fillColor: '#1D68D1',
                strokeColor: '#1D68D1',
              }}
              onClick={(e: any) => {
                // console.log(e.latLng.lat(), e.latLng.lng());
                if (isPlacingWorkOrder) {
                  setAssetDropLocation({
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                  });
                  return;
                }
                setCurrentVenueId(venue.id);
                if (['addBuilding', 'editBuilding'].includes(currentPage) && drawMode === 'draw') {
                  clickedOnMap(e);
                  return;
                }
                setAssetDropLocation({
                  lat: e.latLng.lat(),
                  lng: e.latLng.lng(),
                });
                if (['addAssetCommon', 'addBuilding', 'editAsset'].includes(currentPage)) return;
                if (currentPage === 'addVenue') {
                  // setErrorAlert(true);
                  // setErrorMessage('Venue cannot be created inside an existing venue boundary.');
                  return;
                }
                console.log('Venue clicked:', venue.name, venue.location);
                map?.setCenter(venue.location);
                setCurrentPage('venueDetails');
              }}
              key={venue.id + 'venue_polygon'}
            />
          );
        })}

      {/* Locations of existing venues */}
      {/* {venues &&
        mapManagerVenueDisplay &&
        mapManagerShowAllLayers &&
        !floorPlanGeometry &&
        getOrganisationId() !== 1 &&
        map?.getZoom() &&
        map?.getZoom()! >= 17 &&
        venues.map((venue: any) => {
          if (venue.location === undefined) return;
          if (venue.id === hiddenVenueId) return;
          // when zoomed in, show all venue polygons
          return (
            <Marker
              position={venue.location}
              // visible={[null, ''].includes(currentBuildingId) && [null, ''].includes(currentFloorId)}
              icon={{
                url: VenueIcon,
                scale: 1,
                anchor: new google.maps.Point(12, 12),
                scaledSize: new google.maps.Size(24, 24),
              }}
              onClick={() => {
                if (currentPage !== 'home') return;
                map?.setCenter(venue.location);
                setCurrentVenueId(venue.id);
                setCurrentPage('venueDetails');
                setAssetDropLocation(venue.location);
              }}
              key={venue.id}
            />
          );
        })} */}

      {/* Locations of existing buildings */}
      {/* {currentBuildings &&
        !floorPlanGeometry &&
        // currentPage !== 'buildingDetails' &&
        getOrganisationId() !== 1 &&
        currentBuildings.map((building: any) => {
          return (
            <Marker
              key={building?.id}
              position={building.location}
              // visible={(![null, ''].includes(currentVenueId) || ![null, ''].includes(currentBuildingId)) && [null, ''].includes(currentFloorId)}
              icon={{
                url: BuildingIcon,
                scale: 1,
                anchor: new google.maps.Point(10, 10),
                scaledSize: new google.maps.Size(20, 20),
              }}
              onClick={() => {
                setCurrentBuildingId(building.id);
                setCurrentPage('buildingDetails');
              }}
            />
          );
        })} */}

      <Marker
        position={userLocation}
        icon={{
          url: MyLocationIcon,
          scaledSize: new google.maps.Size(18, 18),
          anchor: new google.maps.Point(9, 9),
        }}
        clickable={false}
        draggable={false}
        visible={userLocation.lat !== 0 && userLocation.lng !== 0}
      />

      <Circle
        center={userLocation}
        visible={userLocation.lat !== 0 && userLocation.lng !== 0 && getRole() === 'installer' && getOrganisationId() === 1}
        radius={INSTALLER_RADIUS}
        options={{
          strokeColor: '#0059B2',
          fillColor: '#0059B2',
          fillOpacity: 0.1,
          strokeOpacity: 0.5,
          strokeWeight: 1,
          clickable: false,
          draggable: false,
          editable: false,
        }}
      />

      {currentPage === 'createRfSimulation' && showRfRadius ? (
        <Circle
          center={rfLocation}
          radius={parseFloat(rfAnalysisForm.internal_radius.toString())}
          options={{
            strokeColor: '#0059B2',
            fillColor: '#0059B2',
            fillOpacity: 0.1,
            strokeOpacity: 0.5,
            strokeWeight: 1,
            clickable: false,
            draggable: false,
            editable: false,
          }}
        />
      ) : (
        <></>
      )}

      <Marker
        position={assetDropLocation}
        icon={{ url: AssetDropIcon }}
        draggable={currentPage === 'createRfSimulation' && rfImageUrl !== '' ? false : true}
        onDragEnd={(e: any) => {
          if (currentPage === 'createRfSimulation' && rfImageUrl !== '') return;

          setAssetDropLocation({ lat: e.latLng.lat(), lng: e.latLng.lng() });

          if (currentPage === 'createRfSimulation' && rfImageUrl === '') {
            setRfLocation({ lat: e.latLng.lat(), lng: e.latLng.lng() });
            getNodesInRadius({ lat: e.latLng.lat(), lng: e.latLng.lng() }, rfAnalysisForm.internal_radius, getTechnology());
          }
        }}
        options={{ draggable: currentPage === 'createRfSimulation' && rfImageUrl !== '' ? false : true, optimized: true }}
        visible={(['createRfSimulation', 'addAssetCommon'].includes(currentPage) && !isAzimuthActive) || isPlacingWorkOrder}
      />

      <Marker
        position={{
          lat: parseFloat(calculateLocation.lat),
          lng: parseFloat(calculateLocation.lng),
        }}
        icon={{ url: AssetDropIcon }}
        draggable={true}
        onDragEnd={(e: any) => {
          setCalculateLocation({
            lat: e.latLng.lat().toFixed(6),
            lng: e.latLng.lng().toFixed(6),
          });
        }}
        options={{ draggable: true, optimized: true }}
        visible={currentPage === 'calculate'}
      />

      <Marker position={center} clickable={false} draggable={false} visible={searchedLocation} />

      {mapManagerObstructionsDisplay &&
        mapManagerConnectivityDisplay &&
        obstructions.length > 0 &&
        obstructions.map((obstruction: any, index: number) => {
          return (
            <Marker
              key={index + obstruction[0] + obstruction[1] + 'obstruction_marker' + index}
              position={{
                lat: obstruction[0],
                lng: obstruction[1],
              }}
              icon={{
                url: ObstructionIcon,
                anchor: new google.maps.Point(10, 10),
                scaledSize: new google.maps.Size(20, 20),
              }}
            />
          );
        })}

      {assetHover && (
        // <InfoWindow
        //   options={{
        //     pixelOffset: map?.getZoom() && map?.getZoom()! >= 15 ? new google.maps.Size(0, -35) : new google.maps.Size(0, -10),
        //   }}
        //   position={hoverData.position}

        //   >
        <CustomPopup map={map as google.maps.Map} position={hoverData.position} visible={assetHover}>
          <div className="col-wise info-win">
            <span className="infowindow-title">{getOrganisationId() !== 1 || hoverData.vendor_type !== 'Nokia' ? 'Asset ID' : 'UID'} </span>
            <span className="infowindow-label">{hoverData.trackingId ?? '-'}</span>

            <span className="infowindow-title">Serial Number </span>
            <span className="infowindow-label">{hoverData.serialNumber === '' ? '-' : hoverData.serialNumber ?? '-'}</span>

            <span className="infowindow-title">Node Name </span>
            <span className="infowindow-label">{hoverData.cbrsNodeName ?? '-'}</span>

            {!['wifi_6e', 'cpe_cbsd', 'cpe_wifi', 'tarana', 'tarana_cpe'].includes(hoverData.technologyType) && (
              <span className="infowindow-title">Mounting Type </span>
            )}
            {!['wifi_6e', 'cpe_cbsd', 'cpe_wifi', 'tarana', 'tarana_cpe'].includes(hoverData.technologyType) && (
              <span className="infowindow-label">{getMountingTypeName[hoverData.mountingType]}</span>
            )}
            {getOrganisationId() !== 1 ? <span className="infowindow-title">Device Type </span> : <></>}

            {getOrganisationId() !== 1 ? <span className="infowindow-label">{getTechnologyName[hoverData.technologyType]}</span> : <></>}

            <span className="infowindow-title">Status </span>
            <span className="infowindow-label">{hoverData.status}</span>
            <div className="left-arrow" />
          </div>
        </CustomPopup>
        // </InfoWindow>
      )}
      {/* {selectedAsset?.base_node_connections &&
        selectedAsset?.base_node_connections.length > 0 &&
        selectedAsset?.base_node_connections.map((connection: any, index: number) => {
          return (
            <CustomPopup
              map={map as google.maps.Map}
              position={{
                lat: connection?.rf_analysis?.Receiver?.[0]?.['Latitude'],
                lng: connection?.rf_analysis?.Receiver?.[0]?.['Longitude'],
              }}
              visible={viewRFPathAnalysis}>
              <div className="col-wise info-win">
                <span className="infowindow-title">Expected signal strength dBm </span>
                <span className="infowindow-label">{connection?.rf_analysis?.Transmitters?.[0]?.['Signal power at receiver dBm'] ?? '-'}</span>

                {/*}  {connection?.rf_analysis?.Transmitters?.[0]?.['Obstructions']?.length > 0 && (
                  <>
                    <span className="infowindow-title">Obstructions </span>
                    <span className="infowindow-label">{connection?.rf_analysis?.Transmitters?.[0]?.['Obstructions']?.length ?? '-'}</span>
                  </>
                )} 

                <span className="infowindow-title">Fresnel clearance </span>
                <div style={{ cursor: 'pointer', zIndex: 10 }} className="d-flex justify-content-start align-items-center">
                  <span className="infowindow-label">
                    {connection?.rf_analysis?.Transmitters?.[0]?.['Raise RX antenna for full fresnel'] == 0
                      ? 'Receiving full clearance'
                      : `Raise Antenna by ${connection?.rf_analysis?.Transmitters?.[0]?.['Raise RX antenna for full fresnel']} meters`}
                  </span>
                  <div
                    key={connection?.id + 'site_image_popup_' + index}
                    className="d-flex flex-column gap-1 ms-2"
                    onClick={() => {
                      // getImage(connection?.rf_analysis?.['Chart image']);
                      setViewImage({
                        image: connection?.rf_analysis?.['Chart image'],
                        fileName: connection?.rf_analysis?.['Chart image'].slice(connection?.rf_analysis?.['Chart image'].lastIndexOf('/') + 1),
                        popup: true,
                        path: connection?.rf_analysis?.['Chart image'],
                      });
                    }}>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        background: '#F5F5F5',
                        borderRadius: '4px',
                        color: '#8F9FAC',
                        height: '20px',
                        cursor: 'pointer',
                        width: '20px',
                      }}>
                      <FileImageOutlined style={{ fontSize: '14px' }} />
                    </div>
                  </div>
                </div>
                <div className="left-arrow" />
              </div>
            </CustomPopup>
          );
        } */}

      {measurePopup &&
        measurePoints.map((point: any, index: number) => {
          return (
            <InfoWindow
              key={point.lat.toFixed(0) + point.lng.toFixed(0)}
              options={{
                pixelOffset: map?.getZoom() && map?.getZoom()! >= 15 ? new google.maps.Size(0, -35) : new google.maps.Size(0, -10),
              }}
              position={point}>
              <div className="col-wise">
                <div className="row-wise">
                  <span className="infowindow-label">Tilt: </span>
                  <span className="infowindow-title ms-2">{`${measureInfo.tilt} deg`}</span>
                </div>

                <div className="row-wise">
                  <span className="infowindow-label">Height: </span>
                  <span className="infowindow-title ms-2">{`${measureInfo.height[index]} ft`}</span>
                </div>
              </div>
            </InfoWindow>
          );
        })}

      {isPlacingWorkOrder && (
        <InfoWindow
          key={assetDropLocation.lat.toFixed(0) + assetDropLocation.lng.toFixed(0)}
          options={{
            pixelOffset: new google.maps.Size(0, -60),
            headerDisabled: true,
          }}
          position={assetDropLocation}>
          <Button
            type="primary"
            onClick={() => {
              addSiteToWorkOrder();
            }}
            disabled={assetDropLocation.lat === 0 && assetDropLocation.lng === 0}
            icon={<CheckOutlined />}>
            Confirm
          </Button>
        </InfoWindow>
      )}
      <MapSpinner show={loading} />
      <ErrorAlert
        show={errorAlert}
        onDismiss={() => {
          setErrorAlert(false);
        }}
        message={errorMessage}
      />
      <WarningAlert
        show={warning.alert}
        onDismiss={() => {
          setWarning({ message: '', alert: false });
        }}
        message={warning.message}
      />

      <Modal show={viewImage.popup}>
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content app-card border-0 p-0">
            <div className="modal-header">
              <h5 className="modal-title">{'Chart Image'}</h5>
              <div className="row-wise download-box ms-2" onClick={downloadImage}>
                <span className="material-icons-round me-1 download-icon">file_download</span>
                <span className="download-label">DOWNLOAD</span>
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={(e: any) => {
                  e.preventDefault();
                  setViewImage({ image: '', fileName: '', popup: false, path: '' });
                }}></button>
            </div>
            <div className="modal-body p-0 overflow-hidden">
              <img
                loading="eager"
                onLoad={() => {
                  setLoading(false);
                }}
                className="w-100"
                src={viewImage.image}
              />
            </div>
          </div>
        </div>
      </Modal>
    </GoogleMap>
  ) : (
    <></>
  );
};

export default Outdoor;
